$(document).ready(function () {
  if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
      position = position || 0;
      return this.indexOf(searchString, position) === position;
    };
  }
});

function layoutSubsidiaryLinks() {
  const $mapOverlay = $('#mapOverlay');
  if (!$mapOverlay.length) {
    // element not found
    return false;
  }
  const overlayRect = $mapOverlay[0].getBoundingClientRect();
  $('.js-filial-link').each(function () {
    const $this = $(this);

    const scalex = overlayRect.width / 960.0;
    const scaley = overlayRect.height / 1250.0;

    const calculatedLeft = $this.attr('data-attribute-link-left') * scalex;
    const calculatedTop = $this.attr('data-attribute-link-top') * scaley;
    $this.attr(
      'style',
      'position: absolute; left: calc(9.6px*' + calculatedLeft + '); top: calc(12.5px*' + calculatedTop + ');'
    );
  });
}
$(document).ready(layoutSubsidiaryLinks);

function hideSubsidiaryEntry($element) {
  $element.addClass('view-hide');
}

function showSubsidiaryEntry($element, name) {
  if (!name) {
    return;
  }
  $element.removeClass('view-hide');
  document.getElementById('ContactPersonDetailHeadline').innerHTML =
    'Ihr(e) Berater in der Filiale ' + name;
}

function namesEqualIgnoreCase(lineA, lineB) {
  return lineA && lineB && lineA.toLowerCase() == lineB.toLowerCase();
}

function containsIgnoreCase(line, search) {
  return line && search && line.toLowerCase().indexOf(search.toLowerCase()) !== -1;
}

export function searchAndMarkSubsidiaryElements(searchString, searchExact) {
  if (!searchString) {
    return;
  }
  function containsOrEqualsOnExact(line, search, searchExact) {
    return searchExact ? line == search : containsIgnoreCase(line, searchString);
  }
  var counter = 0;
  var foundName;
  $('.js-subsidiary-detail').each(function () {
    var $this = $(this);
    var name = $this.attr('data-subsidiary-name');
    var zipcodes = $this.attr('data-subsidiary-zipcodes');
    var location = $this.attr('data-subsidiary-location');

    hideSubsidiaryEntry($this);

    var found =
      containsOrEqualsOnExact(name, searchString, searchExact) ||
      containsOrEqualsOnExact(location, searchString, searchExact);
    zipcodes &&
      zipcodes.split(',').forEach(function (zipcode) {
        found = found || zipcode.indexOf(searchString) !== -1;
      });
    if (found) {
      showSubsidiaryEntry($this, name);
      foundName = name;
      counter++;
    }
  });
  // Search for advisors containing the search-string and show their subsidiaries
  $('.js-overview-advisor-detail').each(function () {
    var name = $(this).attr('data-search-name');
    var subsidiaryListForThisAdvisor = $(this).attr('data-filter-subsidiaries');
    if (name && containsIgnoreCase(name, searchString) && subsidiaryListForThisAdvisor) {
      subsidiaryListForThisAdvisor.split(',').forEach(function (subsidiaryName) {
        $('.js-subsidiary-detail').each(function () {
          var thisSubsidiary = $(this).attr('data-subsidiary-name');
          if (thisSubsidiary === subsidiaryName) {
            showSubsidiaryEntry($(this), subsidiaryName);
            foundName = subsidiaryName;
            counter++;
          }
        });
      });
    }
  });

  if (counter === 1) {
    switchToDetail(foundName);
    var findADetailView = $('.js-overview-advisor-detail').not('.view-hide');
    if (findADetailView && findADetailView.length > 0) {
      scrollTo('.filterContainer');
    } else {
      scrollTo('.js-contactperson-overview-list');
    }
  } else {
    scrollTo('.searchblock');
  }
  if (counter === 0) {
    $('.no-subsidiaries-found').removeClass('view-hide');
  } else {
    $('.no-subsidiaries-found').addClass('view-hide');
  }
}

$('.contactperson-overview-item').on('click', function (e) {
  var subsidiaryName = $(this).attr('data-subsidiary-name');

  var searchfield = $('.js-subsidiary-searchfield');
  searchfield.val(subsidiaryName);

  searchAndMarkSubsidiaryElements(subsidiaryName, true);
});

function switchToOverview() {
  var viewDetail = $('.js-contactperson-detail');
  var backbutton = $('.js-backbutton');
  viewDetail.addClass('view-hide');
  backbutton.addClass('view-hide');
  $('.contactperson-overview-item').each(function () {
    $(this).removeClass('view-hide');
  });
  $('.js-subsidiary-detail-contactdata').each(function () {
    $(this).addClass('view-hide');
  });
}

function switchToDetail(name) {
  var viewDetail = $('.js-contactperson-detail');
  var backbutton = $('.js-backbutton');
  viewDetail.removeClass('view-hide');
  backbutton.removeClass('view-hide');
  $('.contactperson-overview-item').each(function () {
    var subsidiaryName = $(this).attr('data-subsidiary-name');
    if (!subsidiaryName || !namesEqualIgnoreCase(subsidiaryName, name)) {
      $(this).addClass('view-hide');
    } else {
      $(this).removeClass('view-hide');
    }
  });

  $('.advisor-filter-item-special').removeClass('active-filter');
  $('.js-advisor-filter-all').addClass('active-filter');
  $('.js-advisor-filter-all').attr('filter-for-subsidiary', name);

  setAdvisorAndFilterVisibility(name);
}

$('.js-advisor-filter-all').on('click keypress', function (e) {
  $('.advisor-filter-item-special').removeClass('active-filter active');
  $(this).addClass('active-filter');

  setAdvisorAndFilterVisibility($('.js-advisor-filter-all').attr('filter-for-subsidiary'));
});

$('.advisor-filter-item-special').on('click keypress', function (e) {
  $('.js-advisor-filter-all').removeClass('active-filter active');
  $('.advisor-filter-item-special').removeClass('active-filter active');

  $(this).addClass('active-filter');

  setAdvisorAndFilterVisibility($('.js-advisor-filter-all').attr('filter-for-subsidiary'));
});

function setAdvisorAndFilterVisibility(currentSubsidiaryName) {
  // hide all advisors and their filters
  $('.js-overview-advisor-detail').addClass('view-hide');
  $('.advisor-filter-item-special').addClass('view-hide');

  // show the "Alle"-filterbutton
  $('.js-advisor-filter-all').removeClass('view-hide');

  var activeFilterName = $('.active-filter').attr('data-filter-name');

  var countSpecialFilter = 0;
  // check on each advisor detail if it and/or its filter should be shown
  $('.js-overview-advisor-detail').each(function () {
    var advisorName = $(this).attr('data-filter-name');
    var subsidiaryNames = $(this).attr('data-filter-subsidiaries').split(',');

    // only advisors, that have the current selected subsidiary assigned
    if (subsidiaryNames.indexOf(currentSubsidiaryName) !== -1) {
      var filterForAdvisor = $(
        ".advisor-filter-item-special[data-filter-name='" + advisorName + "']"
      );
      if (filterForAdvisor) {
        // Show this filter
        filterForAdvisor.removeClass('view-hide');
        countSpecialFilter++;
      }

      // Filter is on "Alle" -> activeFilterName is falsy, otherwise the activeFiltername should equal the current advisor
      if (!activeFilterName || activeFilterName === advisorName) {
        // Show this advisor
        $(this).removeClass('view-hide');
      }
    }
  });
  // No advisor found: hide whole section and show message "not found"
  if (countSpecialFilter === 0) {
    document.getElementById('ContactPersonDetailHeadline').innerHTML =
      'Es wurden keine Berater für diese Filiale gefunden.';
    $('.js-contactperson-detail-list').addClass('view-hide');
  } else {
    document.getElementById('ContactPersonDetailHeadline').innerHTML =
      'Ihre Berater in der Filiale ' + currentSubsidiaryName;
    $('.js-contactperson-detail-list').removeClass('view-hide');
  }
}

function scrollTo(selector) {
  $([document.documentElement, document.body]).animate(
    {
      scrollTop: $(selector).offset().top,
    },
    1000
  );
}

var searchfield = $('.js-subsidiary-searchfield');
var search = function () {
  switchToOverview();
  searchAndMarkSubsidiaryElements(searchfield.val(), false);
};

$('.js-backbutton').on('click', function (e) {
  searchfield.val('');
  search();
});

$('.js-submitbutton').on('click', search);

searchfield.on('keyup', function (e) {
  if (e.keyCode == 13) {
    search(e);
  }
});
